import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Jmoment from 'moment-jalaali';
import Select from 'react-select';

import ENUMS from '../../enums';
import { domManipulator } from '../../utils';
import * as reserveActions from '../../redux/reservations/actions';

import Spin from '../../components/loading';
import DatePicker from '../../components/FormElements/DatePicker/DatePicker';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

const FinalCheckout = props => {
  let { cafeName, createdAt, fromDate, toDate, reservesCount, auditor, status } = props.checkoutDetails;

  let {
    checkoutDetailsLoading,
    checkoutDetailsError,
    checkoutDetailsFailed,
    checkoutDetailsMessage,

    finalCheckoutLoading,
    finalCheckoutError,
    finalCheckoutFailed,
    finalCheckoutMessage
  } = props;

  let [paidAt, setPaidAt] = useState(' ');
  let [sourceBankName, setSourceBankName] = useState('');
  let [destinationBankName, setDestinationBankName] = useState('');
  let [payerName, setPayerName] = useState('');
  let [payType, setPayType] = useState('');
  let [alert, setAlert] = useState(false);
  let [alertColor, setAlertColor] = useState('success');
  let [alertText, setAlertText] = useState('');
  let [paidAtError, setPaidAtError] = useState('');
  let [payerNameError, setPayerNameError] = useState('');
  let [sourceBankNameError, setSourceBankNameError] = useState('');
  let [destinationBankNameError, setDestinationBankNameError] = useState('');
  let [payTypeError, setPayTypeError] = useState('');

  let payTypeRef = React.createRef('');

  let isExistsError = false;

  const saveForm = () => {
    if (!paidAt) {
      isExistsError = true;
      domManipulator.scrollToTop();
      setAlert(true);
      setAlertText('titles.checkout.paidAt.IsRequired');
      setAlertColor('danger');
      setPaidAtError(locales('titles.checkout.paidAt.IsRequired'));
    }

    if (!payerName) {
      isExistsError = true;
      domManipulator.scrollToTop();
      setAlert(true);
      setAlertText('titles.checkout.payerName.IsRequired');
      setAlertColor('danger');
      setPayerNameError(locales('titles.checkout.payerName.IsRequired'));
    }
    if (!sourceBankName) {
      isExistsError = true;
      domManipulator.scrollToTop();
      setAlert(true);
      setAlertText('titles.checkout.sourceBankName.IsRequired');
      setAlertColor('danger');
      setSourceBankNameError(locales('titles.checkout.sourceBankName.IsRequired'));
    }
    if (!destinationBankName) {
      isExistsError = true;
      domManipulator.scrollToTop();
      setAlert(true);
      setAlertText('titles.checkout.destinationBankName.IsRequired');
      setAlertColor('danger');
      setDestinationBankNameError(locales('titles.checkout.destinationBankName.IsRequired'));
    }
    if (!payType) {
      isExistsError = true;
      domManipulator.scrollToTop();
      setAlert(true);
      setAlertText('titles.checkout.payType.IsRequired');
      setAlertColor('danger');
      setPayTypeError(locales('titles.checkout.payType.IsRequired'));
    }

    if (!isExistsError) {
      const item = {
        id: props.checkoutId,
        paidAt: Jmoment(paidAt).format('jYYYY/jMM/jDD'),
        payerName,
        sourceBankName,
        destinationBankName,
        payType: payType.value
      };

      props.finalCheckoutCafeReserves(item).then(() => {
        const { finalCheckoutFailed, finalCheckoutError, finalCheckoutMessage } = props;
        if (finalCheckoutFailed == false && finalCheckoutMessage == null && finalCheckoutError == false) {
          AlertAndConfirmation({
            title: locales('titles.checkoutDoneSuccessfully'),
            text: '',
            type: 'success'
          });
          setAlert(true);
          setAlertColor('success');
          props.fetchAllCheckedoutOrClientAbsentReserves('sort=createdAt-desc&pageSize=10');
          props.closeModal();
        } else {
          domManipulator.scrollToTop();
        }
      });
    }
  };

  const onPayAt = event => {
    setPaidAt(event.target.value);
    setPaidAtError('');
  };
  const onPayerName = event => {
    setPayerName(event.target.value);
    setPayerNameError('');
  };
  const onSourceBankName = event => {
    setSourceBankName(event.target.value);
    setSourceBankNameError('');
  };
  const onDestinationBankName = event => {
    setDestinationBankName(event.target.value);
    setDestinationBankNameError('');
  };
  const onPayType = item => {
    setPayType(item);
    setPayTypeError('');
  };

  useEffect(() => {
    // props.fetchCheckoutReserveDetails(props.checkoutId);
  }, []);
  return (
    <>
      <Modal id="financial-transaction-modal" size="xl" isOpen={props.isOpen}>
        <ModalHeader>
          <div className="row">
            <div className="col-11">{locales('titles.checkout')}</div>
            <div className="col-1 text-left">
              <a
                href="#"
                className=""
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {/* <div className='col-12 d-flex justify-content-center align-items-center h-100'>  */}
          <Spin spinning={checkoutDetailsLoading || finalCheckoutLoading}>
            <article>
              {checkoutDetailsError || finalCheckoutError ? (
                <div className="alert alert-danger">{locales('messages.server.error')}</div>
              ) : (
                <>
                  {(checkoutDetailsFailed || finalCheckoutFailed) && (
                    <div className="alert alert-danger">{checkoutDetailsMessage || finalCheckoutMessage}</div>
                  )}
                  <article className="col-12">
                    {alert && <div className={`alert alert-${alertColor}`}>{locales(alertText)}</div>}
                    <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                      {locales('titles.basicInfo')}
                    </div>
                    <div className="col-12 d-flex border rounded py-2 px-1 flex-wrap mb-3">
                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('fields.cafe.name')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">{cafeName}</div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0"></div>

                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('tables.count')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">
                          {reservesCount || '---'}
                        </div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0">
                        <div className="col-5 text-muted text-left">{locales('fields.requestTime')} : </div>
                        <div className="col-7 text-left text-dark font-weight-bold font-large">
                          {createdAt}
                        </div>
                      </div>

                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('titles.fromTime')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">{fromDate || '---'}</div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0">
                        <div className="col-5 text-muted text-left">{locales('labels.to.date')} : </div>
                        <div className="col-7 text-left text-dark font-weight-bold font-large">{toDate}</div>
                      </div>

                      <div className="col-6 d-flex align-items-center">
                        <div className="col-5 text-muted">{locales('tables.auditor')} : </div>
                        <div className="col-7 text-dark font-weight-bold font-large">{auditor || '---'}</div>
                      </div>
                      <div className="col-6 d-flex justify-content-end align-items-center p-0">
                        <div className="col-5 text-muted text-left">{locales('tables.payStatus')} : </div>
                        <div className="col-7 text-left text-dark font-weight-bold font-large">{status}</div>
                      </div>
                    </div>
                  </article>
                  <article className="col-12">
                    <main className="panel panel-default">
                      <div className="panel-heading">
                        <i className="fas fa-list-alt px-1" />
                        {locales('titles.checkout.final')}
                      </div>
                      <div className="panel-body">
                        <div className="col-12 d-flex justify-content-start p-0 align-items-center my-4">
                          <div className="col-4 p-0 required">
                            <label className="rsee-form-label">{locales('fields.checkout.paidAt')}</label>
                            <DatePicker
                              marge={true}
                              placeholder="تاریخ"
                              name="paidAt"
                              id="paidAt"
                              className={`${!!paidAtError ? 'is-invalid' : ''} form-control ml-4 required`}
                              placeholder={locales('fields.checkout.paidAt')}
                              onChange={onPayAt}
                              value={paidAt}
                            />
                            {!!paidAtError && <div className="text-danger text-center">{paidAtError}</div>}
                          </div>
                        </div>

                        <div className="col-12 d-flex justify-content-start p-0 align-items-center my-4">
                          <div className="col-4 p-0 required">
                            <label className="rsee-form-label">{locales('fields.checkout.payType')}</label>
                            <Select
                              id="payType"
                              name="payType"
                              className={`rc-dropdown ${!!payTypeError ? 'is-invalid' : ''} w-100 required`}
                              value={payType}
                              options={ENUMS.PAY_TYPES.list.map(x => ({
                                label: x.title,
                                value: x.value
                              }))}
                              placeholder={locales('fields.checkout.payType')}
                              isMulti={false}
                              onChange={onPayType}
                            />
                            {!!payTypeError && <div className="text-danger text-center">{payTypeError}</div>}
                          </div>

                          <div className="col-4 p-0 required"></div>

                          <div className="col-4 p-0 required">
                            <label className="rsee-form-label">{locales('fields.checkout.payerName')}</label>
                            <input
                              className={`${!!payerNameError ? 'is-invalid' : ''} form-control ml-4 required`}
                              value={payerName}
                              placeholder={locales('fields.checkout.payerName')}
                              onChange={onPayerName}
                              maxLength={ENUMS.MAX_LENGTH.fullName}
                            />
                            <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
                            {!!payerNameError && (
                              <div className="text-danger text-center">{payerNameError}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-12 d-flex justify-content-start p-0 align-items-center my-4">
                          <div className="col-4 p-0 required">
                            <label className="rsee-form-label">
                              {locales('fields.checkout.sourceBankName')}
                            </label>
                            <input
                              className={`${
                                !!sourceBankNameError ? 'is-invalid' : ''
                              } form-control ml-4 required`}
                              value={sourceBankName}
                              placeholder={locales('fields.checkout.sourceBankName')}
                              onChange={onSourceBankName}
                              maxLength={ENUMS.MAX_LENGTH.bankName}
                            />
                            <small style={{ color: '#ccc' }}>{locales('maxLength.20')}</small>
                            {!!sourceBankNameError && (
                              <div className="text-danger text-center">{sourceBankNameError}</div>
                            )}
                          </div>

                          <div className="col-4 p-0 required"></div>

                          <div className="col-4 p-0 required">
                            <label className="rsee-form-label">
                              {locales('fields.checkout.destinationBankName')}
                            </label>
                            <input
                              className={`${
                                !!destinationBankNameError ? 'is-invalid' : ''
                              } form-control ml-4 required`}
                              value={destinationBankName}
                              placeholder={locales('fields.checkout.destinationBankName')}
                              onChange={onDestinationBankName}
                              maxLength={ENUMS.MAX_LENGTH.bankName}
                            />
                            <small style={{ color: '#ccc' }}>{locales('maxLength.20')}</small>
                            {!!destinationBankNameError && (
                              <div className="text-danger text-center">{destinationBankNameError}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </main>
                  </article>
                </>
              )}
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex col-12 justify-content-end align-items-center">
            <div className="d-flex col-8 justify-content-start align-items-center">
              <button className="btn btn-success w-20 mx-1" onClick={() => saveForm()}>
                {locales('labels.save')}
              </button>
            </div>
            <div className="col-4 d-flex justify-content-end align-items-center">
              <button className="btn btn-default mx-1" onClick={() => props.closeModal()}>
                {locales('labels.cancel')}
              </button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateToProps = state => {
  return {
    checkoutDetails: state.reservationsReducer.checkoutDetails || {},
    checkoutDetailsLoading: state.reservationsReducer.checkoutDetailsLoading,
    checkoutDetailsMessage: state.reservationsReducer.checkoutDetailsMessage,
    checkoutDetailsFailed: state.reservationsReducer.checkoutDetailsFailed,
    checkoutDetailsError: state.reservationsReducer.checkoutDetailsError,

    finalCheckoutLoading: state.reservationsReducer.finalCheckoutLoading,
    finalCheckoutMessage: state.reservationsReducer.finalCheckoutMessage,
    finalCheckoutFailed: state.reservationsReducer.finalCheckoutFailed,
    finalCheckoutError: state.reservationsReducer.finalCheckoutError
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllCheckedoutOrClientAbsentReserves: query =>
      dispatch(reserveActions.fetchAllCheckedoutOrClientAbsentReserves(query)),
    fetchCheckoutReserveDetails: id => dispatch(reserveActions.fetchCheckoutReserveDetails(id)),
    finalCheckoutCafeReserves: item => dispatch(reserveActions.finalCheckoutCafeReserves(item))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FinalCheckout);
